export function createGoalsApi(http) {
  return {
    list: ({ status } = {}) =>
      http.get(status ? `/api/goals?status=${encodeURIComponent(status)}` : '/api/goals'),
    create: (body) => http.post('/api/goals', body),
    detail: (id) => http.get(`/api/goals/${id}`),
    patch: (id, body) => http.patch(`/api/goals/${id}`, body),
    remove: (id) => http.del(`/api/goals/${id}`),
    reorder: (order) => http.patch('/api/goals/reorder', { order }),
  }
}
